module.exports = __webpack_public_path__ + "static/media/Hund.e566e4e9.PNG";